import React, { useState, useEffect } from 'react'
import Admin from './Admin';

export default function AdminMatchStatDefinitions({ addToast }) {
    const [statDefinitions, setStatDefinitions] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const [statKey, setStatKey] = useState(null);
    const [label, setLabel] = useState(null);
    const [unit, setUnit] = useState(null);
    const [cardType, setCardType] = useState(null);


    // Statisztika tipusok lekérése táblázatba
    useEffect(() => {
        fetch("https://focifanatik.hu/api/adminMatchStatsSelectStatId.php")
            .then((response) => response.json())
            .then((data) => {
                console.log("Kapott adatok:", data);
                setStatDefinitions(data);
            })
            .catch((err) => console.error("Hiba a lekéréskor:", err));
    }, []);

    const handleSave = () => {
        fetch("https://focifanatik.hu/api/adminAddStatDefinition.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "include",
            body: JSON.stringify({
                stat_key: statKey,
                label: label,
                unit: unit,
                card_type: cardType
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    addToast("Statisztika tipus hozzáadva!", "success");
                    setShowModal(false);
                    fetch("https://focifanatik.hu/api/adminMatchStatsSelectStatId.php")
                        .then(res => res.json())
                        .then(data => setStatDefinitions(data))
                        .catch(err => console.error("Fetch hiba:", err));
                } else {
                    addToast(data.error || "Hiba!", "warning");
                }
            })
            .catch(() => addToast("Hálózati hiba!", "danger"));
    };



    //STATISZTIKA TIPUS TÖRLÉSE
    const handleDelete = (id) => {
        if (!window.confirm("Biztosan törölni szeretnéd ezt a statisztika tipust?")) return;

        fetch(`https://focifanatik.hu/api/adminDeleteStatDefinition.php?id=${id}`, {
            method: "DELETE",
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    addToast("Sikeres törlés!", "success")
                    // újratöltjük a listát
                    setStatDefinitions(statDefinitions.filter(type => type.id !== id));
                } else {
                    addToast("Hiba!", "warning")
                }
            })
            .catch(err => console.error("Hálózati hiba:", err));
    };


    const handleCloseModal = () => {
        setShowModal(false)
    };

    return (
        <div className="admin-page">
            <Admin />
            <main className="admin-content">
                <header className="admin-header">
                    <h3>🏆 Statisztikák tipusának kezelése</h3>
                </header>

                <section className="admin-main">
                    <p className="text-muted">Itt tudod kezelni a statisztikák tipusait.</p>

                    <button
                        className="btn btn-success mb-3"
                        onClick={() => {
                            // kiürítjük a mezőket és megnyitjuk az üres modalt
                            setStatKey(null);
                            setLabel(null);
                            setUnit(null);
                            setCardType(null);
                            setShowModal(true);
                        }}
                    >
                        <i className="bi bi-plus-circle"></i> Új statisztika tipus hozzáadása
                    </button>

                    <div className="table-responsive mt-4">
                        <table className="table table-striped text-center align-middle">
                            <thead className="table-success">
                                <tr>
                                    <th>ID</th>
                                    <th>StatKey</th>
                                    <th>Label</th>
                                    <th>Unit</th>
                                    <th>Card Type</th>
                                    <th>Műveletek</th>
                                </tr>
                            </thead>
                            <tbody>
                                {statDefinitions.map((s) =>
                                    <tr key={s.id}>
                                        <td>{s.id}</td>
                                        <td>{s.stat_key}</td>
                                        <td>{s.label}</td>
                                        <td>{s.unit}</td>
                                        <td>{s.card_type}</td>
                                        <td>
                                            <div className="d-flex justify-content-center gap-2">
                                                <button className="btn btn-sm btn-danger" onClick={() => handleDelete(s.id)}>
                                                    <i className="bi bi-trash"></i> Törlés
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </section>
            </main>

            {showModal && (
                <>
                    {/* Sötét háttér */}
                    <div className="custom-modal-backdrop"></div>

                    <div className="custom-modal d-flex justify-content-center align-items-center">
                        <div className="custom-modal-content">

                            {/* CÍM */}
                            <div className="custom-modal-header">
                                <h5 className="modal-title-custom">
                                    Új statisztika tipus létrehozása
                                </h5>
                                <button className="close-btn" onClick={handleCloseModal}>×</button>
                            </div>


                            {/* TARTALOM */}
                            <div className="custom-modal-body">
                                <form>
                                    <div className="mb-3">
                                        <label className="form-label">Stat Key</label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            value={statKey}
                                            onChange={(e) => setStatKey(e.target.value)}
                                        />

                                    </div>


                                    <div className="mb-3">
                                        <label className="form-label">Label</label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            value={label}
                                            onChange={(e) => setLabel(e.target.value)}
                                        />

                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Unit</label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            value={unit}
                                            onChange={(e) => setUnit(e.target.value)}
                                        />

                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Card Type</label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            value={cardType}
                                            onChange={(e) => setCardType(e.target.value)}
                                        />

                                    </div>


                                </form>
                            </div>

                            {/* LÁB */}
                            <div className="custom-modal-footer">
                                <button className="pretty-btn cancel-btn" onClick={handleCloseModal}>
                                    Mégse
                                </button>
                                <button className="pretty-btn save-btn" onClick={handleSave}>
                                    Mentés
                                </button>
                            </div>


                        </div>
                    </div>
                </>
            )}
        </div>
    )
}
